import { createSlice } from '@reduxjs/toolkit'
import { v4 as uuid } from 'uuid'
import { clone } from './salesSessionThunks'

const initialState = {
  order: [],
  byId: {},
  activeId: null,
  enabled: false
}

const salesSessionsSlice = createSlice({
  name: 'salesSessions',
  initialState,
  reducers: {
    setMultiEnabled(state, action) {
      const next = action.payload
      if (state.enabled === next) return
      state.enabled = next
    },
    createSession(state, action) {
      const { id = uuid(), title } = action.payload || {}
      const meta = {
        id,
        title: title || `Sale ${state.order.length + 1}`,
        createdAt: Date.now(),
        snapshot: null
      }
      state.byId[id] = meta
      state.order.push(id)
      state.activeId = id
    },
    saveSnapshot(state, action) {
      const { id, snapshot } = action.payload
      if (!state.byId[id]) state.byId[id] = { id, title: state.byId[id]?.title ?? '' }
      state.byId[id].snapshot = clone(snapshot)
    },
    setActiveSession(state, action) {
      const id = action.payload
      if (state.byId[id]) state.activeId = id
    },
    closeSessionByCallId(state, action) {
      const wanted = String(action.payload ?? '')
      if (!wanted) return

      let targetId = null
      for (let i = state.order.length - 1; i >= 0; i--) {
        const id   = state.order[i]
        const meta = state.byId[id]
        const c =
          meta?.callId ??
          meta?.snapshot?.embedded?.args?.callId ??
          meta?.snapshot?.embedded?.args?.callid
        if (String(c ?? '') === wanted) { targetId = id; break }
      }
      if (!targetId) return

      delete state.byId[targetId]
      state.order = state.order.filter(x => x !== targetId)
      if (state.activeId === targetId) state.activeId = state.order[state.order.length - 1] || null
    },
  }
})

export const {
  setMultiEnabled,
  createSession,
  saveSnapshot,
  setActiveSession,
  closeSessionByCallId
} = salesSessionsSlice.actions

export default salesSessionsSlice.reducer
